const initialState = { from: false, to: false }

const coinDropdownReducer = (state, action) => {
    const { type, payload } = action

    switch (type) {
        case 'CHANGE_STATE': {
            return {
                ...initialState,
                [payload]: !state[payload],
            }
        }
        case 'RESET':
            return initialState

        default:
            return state
    }
}

export { initialState, coinDropdownReducer }
